import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import BuildOrderInformation from './components/BuildOrderInformation';
import ContentsInformation from './components/ContentsInformation';
import KitsInformation from './components/KitsInformation';
import ShowContainer from '../../shared/components/show/showContainer';

const BuildOrdersShow = () => (
  <Container>
    <ShowContainer>
      <BuildOrderInformation />
      <hr />
      <ContentsInformation />
      <hr />
      <KitsInformation />
    </ShowContainer>
  </Container>
);

export default withRouter(connect()(BuildOrdersShow));
